export default function handleResponse(values, initValues) {
    const parsedValues = {};

    for (const [key, value] of Object.entries(initValues)) {
        if (values[key] == null) {
            parsedValues[key] = value;
        } else {
            parsedValues[key] = values[key];
        }
    }

    return parsedValues;
}
